const Constants = {
    FilterSplitChar: "-",
};
Object.freeze(Constants);

export { Constants };
